import Search from "./Search";
import UploadImage from "../UploadImage";
import { useState } from "react";
import Tags from "./Tags";
import validation from "../../../Validations/AddProduct";
import Titel from "../Titel";
import InputField from "../InputField";

import useAxios from '../../../hooks/useAxios';
import RichTextEditor from "../../TextEditor";
import UploadAudio from "../UploadAudio";

const NewProduct = () => {
    const { AxiosPrivate } = useAxios()
    const [data, setData] = useState({ images: [], title: '', title_persian: '', act: [], color: [], subject: [], element: [], style: [], body: '', frame: { id: 81 } })
    const [loading, setLoading] = useState(false)
    const [touch, setTouch] = useState({})
    const errors = validation(data)

    const handleChange = (e) => {
        const { name, value } = e.target
        setData(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (Object.keys(errors).length) {
            setTouch({
                title: true, images: true, category_id: true, artist_id: true,
                body: true, width_pixel: true, height_pixel: true
            })
        } else {
            await AxiosPrivate.post('painting_with_frame/store', data, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: () => {
                    setLoading(true)
                },
            })
                .then(res => {
                    alert(res.data.message);
                    setLoading(false)
                    window.location.reload()
                })
                .catch(err => { alert(err.response?.data.message || 'مشکلی پیش آمده'); setLoading(false) })
        }
    }
    const handleEditorChange = (e) => setData(prev => ({ ...prev, body: e }))

    return (
        <>
            <div className="max-w-xl w-full mx-auto my-4">
                <Titel title='افزودن تابلو آماده' className="md:text-xl" />
                <form className="flex flex-col items-center" onSubmit={handleSubmit}>
                    <div className="flex flex-wrap items-center justify-between mt-6 gap-x-1">
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <UploadImage setData={setData} errors={errors} touch={touch} label='عکس اصلی' name='images' images={data.images} />
                        </div>
                        <InputField label={'عرض'} id={1} max_width={'49%'} name={'width_pixel'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'ارتفاع'} id={2} max_width={'49%'} name={'height_pixel'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'عنوان'} id={7} max_width={'100%'} name={'title'} type={'text'} {...{ data, touch, errors, handleChange }} />
                        <InputField label={'عنوان فارسی'} id={7} max_width={'100%'} name={'title_persian'} type={'text'} {...{ data, touch, errors, handleChange }} />
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[49%] w-full">
                            <Search name='category_id' label='دسته بندی' url='category' errors={errors} touch={touch} setData={setData} />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[49%] w-full">
                            <Search name='category_id_2' label='دسته بندی' url='category' errors={errors} touch={touch} setData={setData} />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[49%] w-full">
                            <Search name='category_id_3' label='دسته بندی' url='category' errors={errors} touch={touch} setData={setData} />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[49%] w-full">
                            <Search name='artist_id' label='هنرمند' url='artist' errors={errors} touch={touch} setData={setData} />
                        </div>
                        <InputField label={'ترتیب در دسته بندی'} id={21} max_width={'49%'} name={'order_category'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'ترتیب در هنرمند'} id={22} max_width={'49%'} name={'order_artist'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'width_orig'} id={11} max_width={'49%'} name={'width_orig'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'height_orig'} id={12} max_width={'49%'} name={'height_orig'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'bit_depth'} id={13} max_width={'49%'} name={'bit_depth'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'dpi'} id={14} max_width={'49%'} name={'dpi'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'vertical'} id={15} max_width={'49%'} name={'vertical'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'سال'} id={10} max_width={'49%'} name={'year'} type={'text'}  {...{ data, touch, errors, handleChange }} />
                        <InputField label={'اولویت نمایش'} id={23} max_width={'49%'} name={'order'} type={'number'}  {...{ data, touch, errors, handleChange }} />
                        <div className="relative pb-6 mb-4 max-w-[100%] w-full">
                            <UploadAudio setData={setData} label='فایل صوتی' name='audio1' />
                        </div>
                        <div className="relative pb-6 mb-4 max-w-[100%] w-full">
                            <UploadAudio setData={setData} label='فایل صوتی دوم' name='audio2' />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <Tags data={data} id={16} setData={setData} errors={errors} touch={touch} name='style' label='سبک‌ها و جنش‌ها' />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <Tags data={data} id={17} setData={setData} errors={errors} touch={touch} name='color' label='رنگ غالب' />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <Tags data={data} id={18} setData={setData} errors={errors} touch={touch} name='subject' label='سوژه' />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <Tags data={data} id={19} setData={setData} errors={errors} touch={touch} name='element' label='ابژه' />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <Tags data={data} id={20} setData={setData} errors={errors} touch={touch} name='act' label='افعال' />
                        </div>
                        <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                            <div className="w-full relative">
                                <RichTextEditor value={data.body} onChange={handleEditorChange} />
                            </div>
                            {touch.body && errors.body && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors.body}</p>}
                        </div>
                        <InputField label={'تایتل'} id={333} max_width={'100%'} name={'seo_title'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'اسلاگ'} id={334} max_width={'100%'} name={'slug'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                        <InputField label={'دیسکریپشن'} id={335} max_width={'100%'} name={'meta_description'} type={'text'}  {...{ data, handleChange, touch, errors }} />
                    </div>
                    <button disabled={loading} className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                     focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ">{loading ?
                            <div role="status">
                                <svg stroke="currentColor" aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin fill-gray-50" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"></path></svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                            : 'ثبت'}</button>
                </form >
            </div >
        </>
    );
};

export default NewProduct;